import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "row",
    "amountInput",
    "itemIdInput",
    "hiddenAmountInput",
    "totalAmount",
    "submitButton"
  ]

  connect() {
    this.updateTotal()
  }

  toggleItem(event) {
    const itemId = event.target.dataset.itemId
    const row = this.rowTargets.find(r => r.dataset.itemId === itemId)
    const amountInput = this.amountInputTargets.find(i => i.dataset.itemId === itemId)
    const itemIdInput = this.itemIdInputTargets.find(i => i.dataset.itemId === itemId)
    const hiddenAmountInput = this.hiddenAmountInputTargets.find(i => i.dataset.itemId === itemId)
    const availableAmount = parseFloat(amountInput.dataset.available)

    if (event.target.checked) {
      amountInput.disabled = false
      amountInput.value = availableAmount.toFixed(2)
      itemIdInput.disabled = false
      hiddenAmountInput.disabled = false
      hiddenAmountInput.value = availableAmount.toFixed(2)
      row.classList.add('bg-blue-50')
    } else {
      amountInput.disabled = true
      amountInput.value = ""
      itemIdInput.disabled = true
      hiddenAmountInput.disabled = true
      hiddenAmountInput.value = ""
      row.classList.remove('bg-blue-50')
    }

    this.updateTotal()
  }

  updateAmount(event) {
    const itemId = event.target.dataset.itemId
    const hiddenAmountInput = this.hiddenAmountInputTargets.find(i => i.dataset.itemId === itemId)
    const amount = parseFloat(event.target.value) || 0
    const availableAmount = parseFloat(event.target.dataset.available)

    if (amount > availableAmount) {
      event.target.value = availableAmount.toFixed(2)
      hiddenAmountInput.value = availableAmount.toFixed(2)
    } else {
      hiddenAmountInput.value = amount.toFixed(2)
    }

    this.updateTotal()
  }

  updateTotal() {
    let total = 0

    this.hiddenAmountInputTargets.forEach(input => {
      if (!input.disabled && input.value) {
        total += parseFloat(input.value) || 0
      }
    })

    this.totalAmountTarget.textContent = `$${total.toFixed(2)}`

    this.submitButtonTarget.disabled = total === 0
  }
}
